import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';


@Injectable({
  providedIn: 'root'
})
export class LocalStoreService {

  private ls = window.localStorage;
  private secretKey = 'tb-super-admin'
  constructor() { }

  public setItem(key:string, value:any) {
    value = JSON.stringify(value);
    this.ls.setItem(key, value);
    return true;
  }

  public getItem(key:string) {
    const value = this.ls.getItem(key);
    try {
      return JSON.parse(value as string);
    } catch (e) {
      return null;
    }
  }

  public setEncrypt(key:string, value:any){
    this.ls.setItem(key, CryptoJS.AES.encrypt(JSON.stringify(value), this.secretKey)as any)
  }

  public getDecrypt(key:string){
    const value = this.ls.getItem(key)
    try {
      return JSON.parse(CryptoJS.AES.decrypt(value as string, this.secretKey).toString(CryptoJS.enc.Utf8))
    } catch (e) {
      return null;
    }
  }

  public get user(){
    return this.getDecrypt('user');
    // try {
    //   return JSON.parse(value as string);
    // } catch (e) {
    //   return null;
    // }
  }

  public clear() {
    this.ls.clear();
  }
}
